import React from 'react';
import IntegrationBlock from '../../index';
import StatusBlock from '../StatusBlock';
import TechData from '../TechData';
import { DELIVERY_TYPE_OZON_FBO_OPTIONS } from '../../../../../../config';

const translateDeliveryType = (type) => {
  if (!type) return null;

  const option = DELIVERY_TYPE_OZON_FBO_OPTIONS.find((item) => item.value === type);
  if (option) return option.label;

  return type;
};

const DeliveryItem = (props) => {
  const { data, modalType, isSaveable, isChangeable } = props;

  return (
    <>
      {data !== null && (
        <>
          <IntegrationBlock
            title="Поставка"
            isChangable={isChangeable}
            modalType={modalType}
            modalData={data}
            isSaveable={isSaveable}
          >
            <p>Тип поставки: {translateDeliveryType(data.supplyData?.type)}</p>
            <p>Склад назначения: {data.supplyData?.warehouseName}</p>
            <p>Склад отгрузки: {data.supplyData?.dropOffWarehouseName}</p>

            <h5>Выгрузка черновика</h5>
            <p>Статус: {data.techData?.draftTechData?.draftStatus}</p>
            <p>
              Синхронизация:{' '}
              {data.techData?.draftTechData?.draftSynchronized
                ? 'Синхронизирован'
                : 'Не синхронизирован'}
            </p>
            {data.techData?.draftTechData?.draftErrors !== undefined &&
              data.techData?.draftTechData?.draftErrors.length !== 0 && (
                <p>
                  Текст ошибки: {data.techData?.draftTechData?.draftErrors[0]?.errorMessage || ''}
                </p>
              )}
          </IntegrationBlock>
          <TechData
            code={data.techData?.draftTechData?.draftCreateOperationId}
            date={data.techData?.draftTechData?.draftRequestTs}
            ozonDate={data.techData?.draftTechData?.draftSyncResultTs}
          />
        </>
      )}
    </>
  );
};

export default DeliveryItem;
